export enum CrmLeadSource {
	Website = 0,
	Referral = 10,
	LinkedIn = 20,
	TradeShow = 30,
	ColdCall = 40,
	Email = 50,
	Other = 60,
}
